import axios from 'axios'
import { compile } from 'path-to-regexp'

const url = (path) => (params) => compile(path)(params)

export const urls = {
  orders: url('/v1/orders/'),
  fundraiserShortcode: url('/v1/fundraisers/shortcode/:shortcode/'),
  fundraiserLeaderboard: url('/v1/fundraisers/:id/leaderboard/'),
  fundraiserProducts: url('/v1/fundraisers/:fundraiserId/products/'),
}

export const API_URL = process.env.REACT_APP_API_URL

const api = axios.create({
  baseURL: API_URL,
})

export default api
